import React, { useState } from "react";
import { getUploadUrl } from "../../../../utils";
import { image } from "../../../../datos";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { UserFormModal } from "../UserFormModal";

const userController = new User();

export function UserItem(props) {
  const { user, onReload } = props;
  const { accessToken, user: currentUser } = useAuth();
  const isAdmin = currentUser?.role?.name === "admin";

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseModal = () => setShowModal(!showModal);
  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  const openUpdateUser = () => {
    setTitleModal(`Actualizar ${user.email}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmMessage(
      user.active
        ? `¿Deseas desactivar al usuario ${user.email}?`
        : `¿Deseas activar al usuario ${user.email}?`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await userController.updateUser(accessToken, user.id, { active: !user.active });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`¿Estás seguro de eliminar al usuario ${user.email}? Esta acción no se puede deshacer.`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await userController.deleteUser(accessToken, user.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const roleColors = {
    admin:    "bg-purple-50 text-purple-700 border-purple-100",
    consulta: "bg-[#151C84]/10 text-[#151C84] border-[#151C84]/15",
  };

  return (
    <>
      <div className="group flex items-center gap-4 p-4 bg-white border border-gray-100 rounded-xl hover:shadow-[0_4px_16px_rgba(21,28,132,0.08)] hover:border-[#151C84]/15 transition-all duration-200">
        {/* Avatar */}
        <div className="relative flex-shrink-0">
          <img
            src={user.avatar ? getUploadUrl(user.avatar) : image.noAvatar}
            alt={user.name}
            className="w-11 h-11 rounded-xl object-cover border border-gray-200"
          />
          <span className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white ${user.active ? "bg-emerald-500" : "bg-gray-300"}`} />
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-sm font-bold text-gray-900 truncate">{user.name}</h3>
            {user.role && (
              <span className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-lg border ${roleColors[user.role.name] || "bg-gray-50 text-gray-600 border-gray-200"}`}>
                {user.role.name}
              </span>
            )}
          </div>
          <p className="text-xs text-gray-500 truncate mt-0.5">{user.email}</p>
        </div>

        {/* Actions — solo admin */}
        {isAdmin && (
          <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <button
              onClick={openUpdateUser}
              className="p-2 text-gray-500 hover:text-[#151C84] hover:bg-[#151C84]/10 rounded-lg transition-all duration-200"
              title="Editar usuario"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>
            <button
              onClick={openDesactivateActivateConfim}
              className={`p-2 rounded-lg transition-all duration-200 ${
                user.active
                  ? "text-gray-500 hover:text-amber-600 hover:bg-amber-50"
                  : "text-gray-500 hover:text-emerald-600 hover:bg-emerald-50"
              }`}
              title={user.active ? "Desactivar" : "Activar"}
            >
              {user.active ? (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                </svg>
              ) : (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              )}
            </button>
            <button
              onClick={openDeleteConfirm}
              className="p-2 text-gray-500 hover:text-[#C81416] hover:bg-[#C81416]/10 rounded-lg transition-all duration-200"
              title="Eliminar"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        )}
      </div>

      <UserFormModal show={showModal} close={onOpenCloseModal} title={titleModal} user={user} onReload={onReload} />

      {/* Confirm dialog */}
      {showConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.2)] p-6 max-w-sm w-full mx-4 animate-scale-in">
            <div className="flex items-center gap-3 mb-4">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${isDelete ? "bg-[#C81416]/10" : "bg-amber-50"}`}>
                {isDelete ? (
                  <svg className="w-5 h-5 text-[#C81416]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                )}
              </div>
              <h3 className="text-base font-bold text-gray-900">Confirmar acción</h3>
            </div>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">{confirmMessage}</p>
            <div className="flex gap-3">
              <button
                onClick={onOpenCloseConfirm}
                className="flex-1 px-4 py-2.5 text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-xl font-semibold transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={isDelete ? onDelete : onActivateDesactivate}
                className={`flex-1 px-4 py-2.5 text-sm text-white rounded-xl font-bold transition-all duration-200 ${
                  isDelete
                    ? "bg-[#C81416] hover:bg-[#8c0e0f] shadow-[0_4px_12px_rgba(200,20,22,0.3)]"
                    : "bg-[#151C84] hover:bg-[#0d125c] shadow-[0_4px_12px_rgba(21,28,132,0.3)]"
                }`}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
